module.exports = __webpack_public_path__ + "static/media/logo_aida.36203e83.png";